import { Dispatch, SetStateAction, createContext } from "react";

interface IModalStateContext {}

export const ModalsStateContext = createContext<IModalStateContext>({});

interface IModalsDispatchContext {
  setShowEditPasswordModal: Dispatch<SetStateAction<boolean>>;
  setShowEditNameModal: Dispatch<SetStateAction<boolean>>;
}

export const ModalsDispatchContext = createContext<IModalsDispatchContext>({
  setShowEditPasswordModal: () => {},
  setShowEditNameModal: () => {},
});
